import { requst } from '../config'

// 日历上数据
export const getMMOCalendarApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/mmo/listByCalendar?
            startDay=${params.startDay}
            &endDay=${params.endDay}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 字典数据树
export const getMMODictTreeApi = dictType => {
    const url = `/system/dict/data/tree?dictType=${dictType}&status=Y`
    return requst.get(url)
}

// 根据日期查询当天数据
export const getMMOByDateApi = params => {
    let url
    switch (params.dateType) {
        case 'day':
            url = `/monitor/mmo/getInfo?
            produceDate=${params.produceDate}
            &locationId=${params.locationId}
            &projectId=${params.projectId}
            &dateType=${params.dateType}`.replace(/\s*/g, '')
            break
        case 'week':
            break
        case 'year':
            break
        default:
            break
    }
    return requst.get(url)
}

// 保存数据
export const postMMODataApi = activityData => {
    const url = `/monitor/mmo/addOrUpdate/`
    return requst.post(url, activityData)
}
